module.exports = __webpack_public_path__ + "static/img/wan-fo-shen-qi-ye.f96ed6a.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/products/wan-fo-shen-qi-ye.jpeg
// module id = vJe4
// module chunks = 1